// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '../../../../../node_module_clones/recompose';
import classNames from 'classnames';

// Components
import ToolbarPopup from '../../components/toolbarPopup/ToolbarPopup';
import TrashPopupContent from './TrashPopupContent';
import ListPlaceholderContextProvider from '../../../../element/elementPlaceholder/ListPlaceholderContextProvider';

// Decorators
import trashDropTargetDecorator from '../trashDropTargetDecorator';

// Actions
import { deselectAllElements } from '../../../../element/selection/selectionActions';

// Context
import { zoomStateContextConsumer } from '../../../../canvas/zoom/ZoomStateContext';

// Constants
import { PopupIds } from '../../../../components/popupPanel/popupConstants';

// Styles
import './TrashPopup.scss';

const mapDispatchToProps = (dispatch) => ({
    deselectAllElements: () => dispatch(deselectAllElements()),
});

const enhance = compose(
    connect(null, mapDispatchToProps),

    // Zoom state context is required here to get the zoom scale of the drop target in ElementDragLayer.js,
    // in order to resize the element drag preview when hovering over different sections
    zoomStateContextConsumer,
    trashDropTargetDecorator,
);

const TrashPopup = ({ connectDropTarget, isHovered }) => {
    // on hover, style the arrow to match the 2px black border of the hovered popup
    const arrowStrokeColor = isHovered ? 'rgba(0, 0, 0, 1)' : 'none';
    const arrowStrokeWidth = isHovered ? 2 : 1;

    return (
        <ListPlaceholderContextProvider>
            <ToolbarPopup
                popupId={PopupIds.TRASH}
                className={classNames('TrashPopup', { hover: isHovered })}
                buttonSelector=".popup-trigger-trash"
                closeOnPointerUp
                distance={12}
                offset={10}
                arrowColor="var(--ui-trash-popup-background)"
                arrowStrokeColor={arrowStrokeColor}
                arrowStrokeWidth={arrowStrokeWidth}
                arrowTranslation="-0.5rem"
            >
                <TrashPopupContent connectDropTarget={connectDropTarget} />
            </ToolbarPopup>
        </ListPlaceholderContextProvider>
    );
};

TrashPopup.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    isHovered: PropTypes.bool,
    closeTrashPopup: PropTypes.func,
    connectDropTarget: PropTypes.func,
};

export default enhance(TrashPopup);
